module.exports = __webpack_public_path__ + "img/Halle_Leer 090.da1a9cd6.jpg";